import "../../chunks/nexus-client-client-TGyNJoMo.mjs";
import { benefit } from "../index-client.mjs";
const benefitWishlist = benefit.wishlist;
const active = benefitWishlist.active;
export {
  active,
  benefitWishlist
};
/*                                     */
